export const locationCoord = (value) => {
  if (value === undefined || value === null || value === "") return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

const getLocationCoords = (location) => {
  if (!location || typeof location !== "object") {
    return { lat: null, lng: null };
  }

  let lat = locationCoord(location.lat);
  let lng = locationCoord(location.lng);

  if (
    (lat === null || lng === null) &&
    Array.isArray(location.coordinates) &&
    location.coordinates.length >= 2
  ) {
    lng = locationCoord(location.coordinates[0]);
    lat = locationCoord(location.coordinates[1]);
  }

  return { lat, lng };
};

export const parseStoredLocation = (location) => {
  if (!location) return null;

  const name = String(
    typeof location === "string" ? location : location.name || "",
  ).trim();
  if (!name) return null;

  const { lat, lng } = getLocationCoords(
    typeof location === "string" ? null : location,
  );
  if (lat === null || lng === null) return { name, lat: null, lng: null };

  return { name, lat, lng };
};

export const toApiLocation = (location) => {
  const parsed = parseStoredLocation(location);
  if (!parsed || parsed.lat === null || parsed.lng === null) return null;

  return {
    name: parsed.name,
    lat: parsed.lat,
    lng: parsed.lng,
  };
};

export const isSameOrganizationLocation = (left, right) =>
  JSON.stringify(toApiLocation(left)) === JSON.stringify(toApiLocation(right));
